/** @internal */
export var addToStringTag;
if (typeof Symbol !== 'undefined') {
    addToStringTag = function (target, tag) {
        target.prototype[Symbol['toStringTag']] = tag;
    };
}
else {
    // tslint:disable-next-line:no-empty
    addToStringTag = function () {
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/NgForage/util/addToStringTag.ts
// module id = 2
// module chunks = 0 1